const text = {
  baseStyle: {
    fontSize: "14px", // Default font size
    fontWeight: "normal",
    lineHeight: "150%",
    color: "#ffffff",
    // fontFamily: "PingFang SC Medium"
    fontFamily: "Rubik, 'sans-serif'",
  },
};
export default text;
